<template>
  <div class="floating-header" :class="{showHeader, relative, noScroll}">
    <div class="fheader-container">
        <fa :icon="['fas', 'chevron-left']" @click="backAction" v-if="!hideArrowBack"/>
        <div v-else />
        <div class="name-container">
        <h2 v-text="title"></h2>
        <span v-text="sbtitle"></span>
        </div>
        <fa v-if="!hideSearch" :icon="['fas', 'search']" @click="startSeach"/>
    </div>

    <div class="tags-container"
      ref="tagContainer"
      v-if="tags && tags.length"
    >
      <div
        v-for="(tag, key) in tags"
        :key="key"
        class="tag"
        :class="{ active: tag.active }"
        :ref="`tag${tag.groupCode}`"
      >
        <a
          :href="`#${tag.groupCode}`"
          @click.prevent="$emit('tagClicked', tag.groupCode, tag.index)"
        >
          {{ tag.groupName }}
        </a>
      </div>
    </div>

    <div class="search-container" v-if="openSearch">
        <input class="search-input" placeholder="Pesquisar" type="text" v-model="searchText" @input="changeSearch">
        <fa :icon="['fas', 'circle-xmark']" @click="clearSearch" v-if="true" class="clear-icon"/>
    </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import { nextTick } from 'vue'
import eventModule from '@/assets/libs/eventModule'

export default {
  name: 'FloatingHeader',
  components: {},
  props: ['headerData', 'tags', 'showHeader', 'relative', 'routeToBack', 'hideSearch', 'hideArrowBack', 'title', 'sbtitle', 'toClear', 'goBackOrHome'],
  data () {
    return {
      openSearch: false,
      searchText: '',
      lastChange: null,
      noScroll: false
    }
  },
  updated () {
    // Emit the ref to the parent once the component is mounted
    this.$emit('sendRef', this.$refs)
  },
  methods: {
    ...mapActions(['updateCurrentItemEdit', 'updateSelectedEvent']),
    startSeach: function () {
      this.openSearch = !this.openSearch
    },
    changeSearch: function () {
      this.lastChange = Date.now()
      const oldText = this.searchText
      const waitingTime = 500
      setTimeout(() => {
        const elapsedTime = Date.now() - this.lastChange
        if (this.searchText === oldText && elapsedTime >= waitingTime) {
          this.lastChange = Date.now()
          this.$emit('search', { text: this.searchText })
        }
      }, waitingTime)
    },
    backAction: function () {
      if (this.toClear) {
        setTimeout(() => {
          this[this.toClear]({})
        }, 100)
      }

      if (this.goBackOrHome) {
        const previousRoute = this.$router.options.history.state.back
        if (previousRoute === '/' || previousRoute === '/profile') {
          this.$router.go(-1)
        } else {
          this.$router.push('/')
        }
      } else {
        this.$router.push(this.routeToBack || '/')
      }
    },
    async scrollChange () {
      await nextTick()
      const eventContainer = document.getElementById('event-container')
      if (eventContainer) {
        if (eventContainer.scrollHeight === eventContainer.clientHeight) {
          this.noScroll = true
        } else {
          this.noScroll = false
        }
      }
    },
    clearSearch: function () {
      this.searchText = ''
      this.$emit('search', { text: this.searchText })
      this.openSearch = false
    }
  },
  mounted () {
    eventModule.on('scrollChange', this.scrollChange)
  },
  unmounted () {
    eventModule.off('scrollChange', this.scrollChange)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.floating-header {
  pointer-events: none;
  position: fixed;
  z-index: 10;
  opacity: 0;
  right: 0;
  left: 0;
  top: -125px;
  transition: .2s linear all;

  .fheader-container {
    background: white;
    display: grid;
    grid-template-columns: 40px calc(100% - 80px) 40px;
    vertical-align: middle;
    padding: 11px 10px;

    svg, h2, span {
      vertical-align: middle;
      margin: auto;
      text-align: center;
    }
    span {
      font-size: 14px;
      display: block;
      text-align: center;
    }
    svg {
      color: var(--primaryColor);
      font-size: 24px;
    }
    h2 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 16px;
      display: block;
      max-width: 100%;
      color: #3e3e3e;
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 0;
      background: #717171;
      opacity: 0.2;
      border-radius: 100%;
    }
  }
  .tags-container {
      background: white;
      position: relative;
      display: block;
      white-space: nowrap;
      max-width: 100%;
      overflow: auto;
      padding: 10px 0 20px 0;

      .tag {
          margin: 0 5px;
          display: inline-block;
          padding: 10px 16px;
          background: #f0f0f0;
          border-radius: 8px;
          a {
              color: black;
              text-decoration: none;
          }
          &.active {
            background: var(--primaryColor);
            a {
              color: white;
            }
          }
      }
  }
  .search-container {
    background: #fff;
    position: relative;
    display: flex;
    padding: 6px 15px 12px 15px;
    gap: 5px;
    align-items: center;
    justify-content: center;
    .search-input {
      width: 80%;
      padding: 0.5rem;
      border: solid 1px #CCC;
      border-radius: 6px;
    }
    .clear-icon  {
      justify-content: center;
      margin-right: 0 auto;
      font-size: 22px;
      color: var(--primaryColor);
    }
  }
  &.showHeader, &.noScroll {
    pointer-events: auto;
    opacity: 1;
    top: 0;
  }
  &.relative {
    position: relative;
    pointer-events: auto;
    opacity: 1;
    top: 0;
  }
}
</style>
